export default __webpack_public_path__ + "static/media/security.1221ee61.svg";